import { Box } from '@wix/design-system';
import React from 'react';
export const RuleHelperLayout = _ref => {
  let {
    children,
    backgroundColor = 'B60'
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    backgroundColor: backgroundColor,
    borderRadius: "6px",
    padding: "8px SP2"
  }, children);
};
//# sourceMappingURL=rule-helper-layout.js.map